import { useContext } from "react";
import { authContext } from "../components/AuthContextProvider";


export function useAuth() {
  return useContext(authContext);
}